import { kf1AuthenticatedHttpClient } from "kfone-frontend-core";
import {
  API_METHODS,
  API_URL,
  MAX_API_TIMEOUT
} from "../constants/api.constants";
import { AppEnvVariables } from "../constants/environment.constants";
import { getLanguageCode, getPayloadLanguage } from "../utilities/helper";
import { SuccessProfileDetailsQueryParams } from "../helpers/models/JobPricingDetailModels";
import { JobPricingPayloads } from "../helpers/models/JobPricingSearchModels";
import { PeerGroupsFiltersPayload } from "../model/interfaces/peergroupsfilter";

export let cancelReportDetailsAPI: AbortController;
export let cancelSuccessProfileDetailsAPI: AbortController;
export let cancelPricingFiltersAPI: AbortController;

const getPercentileData = async () => {
  /* const url =
    AppEnvVariables.REDIRECT_URI + "mock_data/PercentileListMockData.json"; */
  const url =
    AppEnvVariables.SJPR_API_URL +
    API_URL.PERCENTILE_DATA +
    "?language=" +
    getLanguageCode();
  return await kf1AuthenticatedHttpClient({
    method: API_METHODS.GET,
    url
  });
};

const getReportDetails = async (payload: JobPricingPayloads) => {
  if (cancelReportDetailsAPI && !cancelReportDetailsAPI.signal.aborted) {
    // cancel the report details API request if it is running
    cancelReportDetailsAPI.abort();
  }
  cancelReportDetailsAPI = new AbortController();
  /* const url =
    AppEnvVariables.REDIRECT_URI + "mock_data/JobPricingDetailsMockData.json"; */
  const url = AppEnvVariables.SJPR_API_URL + API_URL.JOB_PRICING_REPORT_DETAILS;
  const data = { ...payload, language: getPayloadLanguage() };
  return await kf1AuthenticatedHttpClient({
    method: API_METHODS.POST,
    url,
    data,
    timeout: MAX_API_TIMEOUT,
    // headers: {
    //   "Content-Type": "text/plain"
    // },
    signal: cancelReportDetailsAPI.signal
  });
};

const getSuccessProfileDetails = async (
  payload: SuccessProfileDetailsQueryParams
) => {
  cancelSuccessProfileDetailsAPI = new AbortController();
  const url = `${AppEnvVariables.SJPR_API_URL}${API_URL.SUCCESS_PROFILE_DETAILS}?countrycode=${payload.countrycode}&language=${payload.language}&jobcode=${payload.jobcode}&grade=${payload.grade}`;
  return await kf1AuthenticatedHttpClient({
    method: API_METHODS.GET,
    url,
    data: payload,
    timeout: MAX_API_TIMEOUT,
    // headers: {
    //   "Content-Type": "text/plain"
    // },
    signal: cancelSuccessProfileDetailsAPI.signal
  });
};

const getPricingFilters = async (filters: any) => {
  if (cancelPricingFiltersAPI && !cancelPricingFiltersAPI.signal.aborted) {
    // cancel the pricing filters API request if it is running
    cancelPricingFiltersAPI.abort();
  }
  cancelPricingFiltersAPI = new AbortController();
  /* const url =
    AppEnvVariables.REDIRECT_URI + "mock_data/JobPricingDetailsMockData.json"; */
  const url = AppEnvVariables.SJPR_API_URL + API_URL.JOB_PRICING_FILTERS;
  const baseParams = {
    method: API_METHODS.POST,
    url,
    timeout: MAX_API_TIMEOUT,
    // headers: {
    //   "Content-Type": "text/plain"
    // },
    signal: cancelPricingFiltersAPI.signal
  };
  const methodParams = filters ? { ...baseParams, data: filters } : baseParams;
  return await kf1AuthenticatedHttpClient(methodParams);
};

const getPeerGroupsFilters = async (payload?: PeerGroupsFiltersPayload) => {
  const url = `${AppEnvVariables.API_URL}${API_URL.PEER_GROUPSLIST}?marketdefinitionkey=${payload?.mktDefinitionKey}&countrycode=${payload?.countryCode}`;

  try {
    const response = await kf1AuthenticatedHttpClient({
      method: API_METHODS.GET,
      url
    });
    return response;
  } catch (error) {
    console.error("Service: API error:", error);
    throw error;
  }
};

const getCustomGradesFilters = async (payload?: any) => {
  const url = `${AppEnvVariables.API_URL}${API_URL.CUSTOM_GRADES}?countrycode=${payload.countryCode}`;

  try {
    const response = await kf1AuthenticatedHttpClient({
      method: API_METHODS.GET,
      url
    });
    return response;
  } catch (error) {
    console.error("Service: API error:", error);
    throw error;
  }
};

export {
  getCustomGradesFilters,
  getPeerGroupsFilters,
  getPercentileData,
  getPricingFilters,
  getReportDetails,
  getSuccessProfileDetails
};
